import React, { useState, useEffect } from "react";
import { DataGrid, GridColDef, GridRenderCellParams } from "@mui/x-data-grid";

import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@mui/material";
import { GridSortModel, GridFilterModel } from "@mui/x-data-grid";

import axiosExt from '../axios';
import { Contact, Customer } from "../types";
import { API_BASE_URL } from "../config.ts";
import { useTranslation } from "react-i18next";

import AddContactDialog from "./AddContactDialog";

//import { useNavigate } from "react-router-dom";
//import { useSearchParams } from "react-router-dom";

interface Props {
    customerId?: string;
}

const ContactTable: React.FC<Props> = ({ customerId }) => {
    const { t } = useTranslation();

    const [contacts, setContacts] = useState<Contact[]>([]);
    const [customers, setCustomers] = useState<Customer[]>([]);
    const [loading, setLoading] = useState(false);
    //const [open, setOpen] = useState(false);
    const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);

    const [selectedContact, setSelectedContact] = useState<Contact | null>(null);
    const [contactToDelete, setContactToDelete] = useState<string | null>(null);

    const [addContactDialogOpen, setAddContactDialogOpen] = useState(false);

    //const email = useState<string>(selectedContact?.email || "");
    //const [email, setEmail] = useState<string>(selectedContact?.email || "");
    //const [error, setError] = useState<boolean>(false);
    //const [helperTextEmail, setHelperTextEmail] = useState<string>("");

    //const [customer, setCustomer] = useState<number | null>(null);
    //const [customerError, setCustomerError] = useState<boolean>(false);
    //const [helperCustomer, setHelperCustomer] = useState<string>("");

    const [sortModel, setSortModel] = useState <GridSortModel>([]);
    const [filterModel, setFilterModel] = useState<GridFilterModel>({ items: [] });

    const [settings, setSettings] = useState<Record<string, string>>({});

    //const [saving, setSaving] = useState(false);

    const savedSortKey = "sortContactList";
    const savedFilterKey = "filterContactList";
    //const navigate = useNavigate();

    //const [searchParams] = useSearchParams();
    //const customerId = searchParams.get("customerId") ? parseInt(searchParams.get("customerId")!) : undefined;

    useEffect(() => {
        const savedSortModel = JSON.parse(localStorage.getItem(savedSortKey) ?? "[]");
        const savedFilterModel = (() => {
            try {
                const parsed = JSON.parse(localStorage.getItem(savedFilterKey) ?? "{}");
                return parsed && parsed.items ? parsed : { items: [] };
            } catch (error) {
                console.error("Error parsing savedFilterKey:", error);
                return { items: [] }; // Fallback
            }
        })();
        setSortModel(savedSortModel);
        setFilterModel(savedFilterModel);
        fetchSettings();
        fetchContacts();
        fetchCustomers();
    }, [customerId]);

    // Save sortModel changes to localStorage
    const handleSortModelChange = (newModel: GridSortModel) => {
        setSortModel(newModel);
        localStorage.setItem(savedSortKey, JSON.stringify(newModel));
    };

    // Save filterModel changes to localStorage
    const handleFilterModelChange = (newModel: GridFilterModel) => {
        setFilterModel(newModel);
        localStorage.setItem(savedFilterKey, JSON.stringify(newModel));
    };

    /*const handleCustomerChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        const selectedCustomer = event.target.value as number;
        setCustomer(selectedCustomer);
        if (!selectedCustomer) {
            setCustomerError(true);
            setHelperCustomer("Customer is required");
        } else {
            setCustomerError(false);
            setHelperCustomer("");
        }
    };*/

    const fetchSettings = async () => {
        setLoading(true);

        try {
            const token = localStorage.getItem("token");
            const response = await axiosExt.get(`${API_BASE_URL}/settings`, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                },
            });
            setSettings(response.data);
        } catch (error) {
            console.error("Error fetching settings:", error);
        } finally {
            setLoading(false);
        }


    };

    const fetchContacts = async () => {
        setLoading(true);

        try {
            const token = localStorage.getItem("token");
            const searchParam = customerId ? `search=${customerId}` : "";
            const response = await axiosExt.get<Contact[]>(`${API_BASE_URL}/contacts?${searchParam}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                    },
                }
            );
            if (response.status === 401) {
                throw new Error("Unauthorized. Please log in again.");
            }

            setContacts(response.data);
        } catch (error) {
            console.error("Error fetching contacts:", error);
        } finally {
            setLoading(false);
        }

       
    };

    const fetchCustomers = async () => {
        const token = localStorage.getItem("token");

        try {
            const response = await axiosExt.get<Customer[]>(`${API_BASE_URL}/customers`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
            }

            );

            if (response.status === 401) {
                throw new Error("Unauthorized. Please log in again.");
            }

            setCustomers(response.data);
        } catch (error) {
            console.error("Error fetching customers:", error);
        }

        

    };

    const handleEdit = (contact: Contact) => {
        setSelectedContact(contact);
        //setOpen(true);
        setAddContactDialogOpen(true);
    };

    const handleCancelDelete = () => {
        setConfirmDeleteOpen(false);
        setContactToDelete(null);
    };

    const handleConfirmDelete = async () => {
        const token = localStorage.getItem("token");
        if (contactToDelete === null) return;
        try {
            await axiosExt.delete(`${API_BASE_URL}/contacts/${contactToDelete}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setContacts(contacts.filter((c) => c.id !== contactToDelete));
        } catch (error) {
            console.error("Error deleting contact:", error);
        }
        finally {
            setConfirmDeleteOpen(false);
            setContactToDelete(null);
        }
    };

    const handleDeleteClick = async (id: string) => {
        try {
            setContactToDelete(id);
            setConfirmDeleteOpen(true);
        } catch (error) {
            console.error("Error deleting record:", error);
        }
    };

    //const handleSave = async () => {
    //    const token = localStorage.getItem("token");

    //    if (selectedContact) {
    //        if (!validateEmail(selectedContact.email)) {
    //            setError(true);
    //            setHelperTextEmail("Invalid email format");
    //            return;
    //        }
    //        /*if (selectedContact.customerId == "") {
    //            setCustomerError(true);
    //            setHelperCustomer("Please select a customer");
    //            return;
    //        }*/

    //        setSaving(true);

    //        try {
    //            if (selectedContact.id === "") {
    //                const payload: Contact = {
    //                    ...selectedContact
    //                };
    //                delete payload.id; // Remove the id field'
    //                if (!selectedContact.customerId)
    //                    delete payload.customerId;
    //                // Add new contact
    //                const response = await axiosExt.post(`${API_BASE_URL}/contacts`, payload, {
    //                    headers: {
    //                        Authorization: `Bearer ${token}`,
    //                    },
    //                });
    //                setContacts([...contacts, response.data]);
    //            } else {
    //                // Update existing contact
    //                await axiosExt.put(`${API_BASE_URL}/contacts/${selectedContact.id}`, selectedContact, {
    //                    headers: {
    //                        Authorization: `Bearer ${token}`,
    //                    },
    //                });
    //                setContacts(
    //                    contacts.map((c) =>
    //                        c.id === selectedContact.id ? selectedContact : c
    //                    )
    //                );
    //            }
    //            setOpen(false);
    //            setSelectedContact(null);
    //        } catch (error) {
    //            console.error("Error saving contact:", error);
    //        } finally {
    //            setSaving(false);
    //        }
    //    }
    //};

    /*const handleClose = () => {
        setSelectedContact(null);
        setAddContactDialogOpen(false);
    };*/

    const showSurveyColumn =
        parseInt(settings["CustomerSatisfactionSurvey:SurveySendingDays"] ?? "-1", 10) >= 0;

    const columns: GridColDef[] = [
        {
            field: "customerId", headerName: t("Customer"), width: 100, valueGetter: (params) => {
                const customer = customers.find(u => u.id === params);
                return customer ? customer.name : '';
            }
        },
        { field: "firstName", headerName: t("First Name"), width: 150 },
        { field: "lastName", headerName: t("Last Name"), width: 150 },
        { field: "email", headerName: t("Email"), width: 200 },
        { field: "mobile", headerName: t("Mobile"), width: 150 },
        { field: "phone", headerName: t("Phone"), width: 150 },
        { field: "title", headerName: t("Title"), width: 150 },
        { field: "emailKey", headerName: t("Email Key"), width: 150 },
        ...(showSurveyColumn
            ? [
                {
                    field: "sendSatisfactionSurvey",
                    headerName: t("Send Satisfaction Survey"),
                    width: 200,
                    type: "boolean"
                } as GridColDef
            ]
            : []),
        {
            field: "actions",
            headerName: "Actions",
            width: 300,
            renderCell: (params: GridRenderCellParams) => (
                <>
                    <Button
                        variant="contained"
                        onClick={() => handleEdit(params.row as Contact)}
                        style={{ marginRight: "10px" }}
                    >
                        {t("Edit")}
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={() => handleDeleteClick(params.row.id)}
                    >
                        {t("Delete")}
                    </Button>
                </>
            ),
        },
    ];

    return (
        <div style={{ height: "100%" }}>
            <div style={{ width: "100%", display: "flex", marginTop: "0px" }}>
                <h2>
                    {customerId
                        ? `${t("Contacts for Customer")} ${customers.find(c => c.id === customerId)?.name || t("Customer Not Found")}`
                        : t("All Contacts")}
                </h2>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                        setSelectedContact({
                            id: "", // 
                            firstName: "",
                            lastName: "",
                            email: "",
                            mobile: "",
                            phone: "",
                            customerId: customerId || "",
                            title: "",
                            emailKey: "",
                            sendSatisfactionSurvey: false,
                        });
                        //setOpen(true);
                        setAddContactDialogOpen(true);
                    }}
                    style={{ marginBottom: "20px", marginTop: "20px", marginLeft: "20px" }}
                >
                    {t("Add New")}
                </Button>
            </div>
            <div style={{  width: "100%" }}>
                <DataGrid 
                    rows={contacts}
                    columns={columns}
                    sortModel={sortModel}
                    onSortModelChange={handleSortModelChange}
                    filterModel={filterModel}
                    onFilterModelChange={handleFilterModelChange}
                    initialState={{
                        pagination: {
                            paginationModel: { pageSize: 25, page: 0 },
                        },
                    }}
                    pageSizeOptions={[25, 50, 100, 200]} 
                    loading={loading}
                />
                <Dialog open={confirmDeleteOpen} onClose={handleCancelDelete}>
                    <DialogTitle>Confirm Deletion</DialogTitle>
                    <DialogContent>Are you sure you want to delete this record?</DialogContent>
                    <DialogActions>
                        <Button onClick={handleCancelDelete} color="secondary">{t("no")}</Button>
                        <Button onClick={handleConfirmDelete} color="error">{t("yes")}</Button>
                    </DialogActions>
                </Dialog>
            </div>
            <AddContactDialog
                open={addContactDialogOpen}
                onClose={() => {
                    setAddContactDialogOpen(false);
                    setSelectedContact(null);
                }}
                customerId={customerId}
                email={selectedContact?.email || "" }
                selectedContact={selectedContact}
                allowSurvey={
                    parseInt(settings["CustomerSatisfactionSurvey:SurveySendingDays"] ?? "-1", 10) >= 0
                } 
                onContactAdded={(newContact) => {
                    setContacts(prev => [...prev, newContact]);
                    setAddContactDialogOpen(false);
                    setSelectedContact(null);
                }}
                onContactUpdated={(updatedContact) => {
                    setContacts(prev =>
                        prev.map(c => c.id === updatedContact.id ? updatedContact : c)
                    );
                    setAddContactDialogOpen(false);
                    setSelectedContact(null);
                }}
            />
            
        </div>
    );
};

export default ContactTable;
